import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SignaturePreviewGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (sessionStorage.getItem('adType') === 'gapi') {
      return this.router.createUrlTree(['/me/me-attributes']);
    }
    return true;
  }
}
